import { LOADER_STATUS, ITC_TABLE_DATA } from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import { errorToastMessage, successToastMessage } from "utils/errorToast";
import {
  areMonthsInTwoFinancialYears,
  extractMonthsInRange,
  extractMonthsInRangeMMYYYY,
} from "../Utility/utility";
export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setITCTableData(itcTableData) {
  return {
    type: ITC_TABLE_DATA,
    itcTableData: itcTableData,
  };
}

export const downloadITCExcel =
  (tableData) => async (dispatch) => {
    dispatch(loader(true));
    const data = {
      tableData
    };
    try { 
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/downloadItcScreen`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_ITC.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Data downloaded successfully");
    } catch (error) {
      errorToastMessage("Failed to download data");
    } finally {
      dispatch(loader(false));
    }
  };
  
export const downloadITCIndividualExcel = (row) => async (dispatch) => {
  dispatch(loader(true));
  // Convert row.GSTIN to an array of strings if it's a comma-separated string
  const gstinArray =
    typeof row.GSTIN === "string" ? row.GSTIN.split(",") : row.GSTIN;
  const periodArray =
    typeof row.RET_PERIOD === "string"
      ? row.RET_PERIOD.split(",")
      : row.RET_PERIOD;

  const data = {
    gstin: gstinArray,
    ret_period: periodArray,
    fileId: row.FILE_ID ?? ''
  };
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR2a2bnew/downloadItcdata`,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
      validateStatus: () => true, // allow handling all status codes manually
    });

    if (response.status === 200 && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_ITC.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      successToastMessage("File downloaded successfully");
    } else {
      errorToastMessage("Failed to download File");
    }
  } catch (error) {
    errorToastMessage("Failed to download File");
  } finally {
    dispatch(loader(false));
  }
};
export const getITCData = (
  selectedGstin,
  startDate,
  endDate,
  dateRange,
  recoType,
  mark3bType,
  search
) => {
  return async (dispatch) => {
    const return_period = extractMonthsInRange(startDate, endDate);

    // Validate financial years
    if (!areMonthsInTwoFinancialYears(return_period)) {
      errorToastMessage("Selection of maximum 2 FYs is allowed");
      return [];
    }

    const requestData = {
      gstin: selectedGstin,
      ret_period: return_period,
      dateRange,
      recoType,
      mark3bType,
      search,
    };

    const apiUrl = `${Config.url}gstR2a2bnew/generateITCReport`;

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: apiUrl,
        data: requestData,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage(response.data.message);
        dispatch(setITCTableData(response.data.data));
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        dispatch(setITCTableData([]));
        return [];
      }
    } catch (error) {
      // Handle different types of errors
      console.log("error in getITCData:", error);
      errorToastMessage("Failed to fetch ITC data.");

      dispatch(setITCTableData([]));
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
};
